var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0L20 6V22C20 23.1046 19.1046 24 18 24H2C0.895431 24 0 23.1046 0 22V2C0 0.89543 0.895431 0 2 0H14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0L15.1314 -1.13137L14.6627 -1.6H14V0ZM20 6H21.6V5.33726L21.1314 4.86863L20 6ZM12.8686 1.13137L18.8686 7.13137L21.1314 4.86863L15.1314 -1.13137L12.8686 1.13137ZM18.4 6V22H21.6V6H18.4ZM18.4 22C18.4 22.2209 18.2209 22.4 18 22.4V25.6C19.9882 25.6 21.6 23.9882 21.6 22H18.4ZM18 22.4H2V25.6H18V22.4ZM2 22.4C1.77909 22.4 1.6 22.2209 1.6 22H-1.6C-1.6 23.9882 0.0117767 25.6 2 25.6V22.4ZM1.6 22V2H-1.6V22H1.6ZM1.6 2C1.6 1.77909 1.77909 1.6 2 1.6V-1.6C0.0117769 -1.6 -1.6 0.0117738 -1.6 2H1.6ZM2 1.6H14V-1.6H2V1.6Z",
    fill: "#172B4D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L14 0V6H20Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11H15",
    stroke: "#172B4D",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14H15",
    stroke: "#172B4D",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H11",
    stroke: "#172B4D",
    strokeWidth: 1.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-doc.dd6d869844f30dffdcae9d392cb2cef8.svg";